import {
  REFRESH_TOKEN,
  // FETCH_ME,
  NOT_LOGGED_IN,
  FETCH_ME_SUCCESS,
  FETCH_USER_SUCCESS,
  FETCH_SECURITY_SUCCESS,
  FETCH_SECURITY_FAIL,
  // FETCH_ME_FAIL,
  // SIGN_OUT_BEGIN,
  SIGN_OUT_SUCCESS,
  // SIGN_OUT_FAILURE,
  DISABLE_OTP_SUCCESS,
  DISABLE_OTP_FAIL,
  ENABLE_OTP_SUCCESS,
  ENABLE_OTP_FAIL,
  ACTIVATE_OTP_SUCCESS,
  ACTIVATE_OTP_FAIL,
  VALIDATE_PASSWORD_SUCCESS,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAIL,
  UPDATE_PWD_SUCCESS,
  UPDATE_PWD_FAIL,
  VALIDATE_PASSWORD_FAIL,
  CREATE_DOCS_SUCCESS,
  CREATE_DOCS_FAIL,
  FETCH_IDENTITY_SUCCESS,
  FETCH_IDENTITY_FAIL,
  CREATE_IDENTITY_SUCCESS,
  CREATE_IDENTITY_FAIL,
  CREATE_TOKEN_SUCCESS,
  CREATE_TOKEN_FAIL,
  DELETE_TOKEN_SUCCESS,
  DELETE_TOKEN_FAIL,
  FETCH_TOKENS_SUCCESS,
  REQUEST_VERIFICATIONS_STATUS_SUCCESS,
  REQUEST_VERIFICATIONS_STATUS_FAILURE,
  REQUEST_VERIFICATIONS_STATUS_BEGIN,
  TOGGLE_TEMP_ANON_SUCCESS,
  CREATE_MASTER_PASSWORD_SUCCESS,
  CREATE_MASTER_PASSWORD_FAIL,
  RESET_MASTER_PASSWORD_SUCCESS,
  RESET_MASTER_PASSWORD_FAIL,
  ACTIVATE_GLOBAL_SETTINGS_LOCK_SUCCESS,
  ACTIVATE_GLOBAL_SETTINGS_LOCK_FAIL,
  DEACTIVATE_GLOBAL_SETTINGS_LOCK_SUCCESS,
  DEACTIVATE_GLOBAL_SETTINGS_LOCK_FAIL,
  FETCH_LOGIN_HISTORY_SUCCESS,
  FETCH_LOGIN_HISTORY_FAIL,
  REQUEST_EMAIL_CHANGE_SUCCESS,
  REQUEST_EMAIL_CHANGE_FAIL,
  UPDATE_USER_TERMS_VERSION_SUCCESS,
  UPDATE_USER_TERMS_VERSION_FAIL,
  FETCH_LOGIN_SESSIONS_SUCCESS,
  FETCH_LOGIN_SESSIONS_FAIL,
  EXPIRE_LOGIN_SESSION_SUCCESS,
  EXPIRE_LOGIN_SESSION_FAIL,
  FETCH_SIWE_NONCE_FAIL,
  FETCH_SIWE_NONCE_SUCCESS,
  TOGGLE_SIWE_SUCCESS,
  TOGGLE_SIWE_FAIL,
} from '../actions/types';

let tempAnon = false;

if (localStorage.getItem('vtanon')) {
  tempAnon = true;
}

const initialState = {
  loading: true,
  me: { }, // change to me
  identity: {},
  full: {},
  token: null,
  redirect: null,
  errors: null,
  tempAnon,
  success: [],
  verification: {
    loading: false
  },
  loginHistory: [],
  loginPagination: [],
  loginSessions: [],
  accessToken: '',
};

const user = (state = initialState, action) => {
  switch (action.type) {
    case REFRESH_TOKEN:
      return {
        ...state,
        accessToken: action.payload,
      };
    case SIGN_OUT_SUCCESS:
      return {
        ...state,
        redirect: '/login', // addd the original path here
      };
    case FETCH_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        full: action.payload,
      };
    case FETCH_ME_SUCCESS:
      return {
        ...state,
        loading: false,
        me: action.payload,
      };
    case FETCH_SECURITY_FAIL:
      return {
        ...state,
        loading: false,
        errors: action.errors,
      };
    case FETCH_SECURITY_SUCCESS:
      return {
        ...state,
        loading: false,
        security: action.payload,
      };
    case FETCH_SIWE_NONCE_FAIL:
      return {
        ...state,
        loading: false,
        errors: action.errors,
      };
    case FETCH_SIWE_NONCE_SUCCESS:
      return {
        ...state,
        loading: false,
        siweNonce: action.payload,
      };      
    case NOT_LOGGED_IN:
      return {
        ...state,
        loading: false,
        errors: action.errors,
        redirect: '/login',
      };
    case VALIDATE_PASSWORD_SUCCESS:
      return {
        ...state,
        pwdToken: action.payload.token,
        loading: false,
      };
    case VALIDATE_PASSWORD_FAIL:
      return {
        ...state,
        loading: false,
        errors: action.errors.response.data,
      };
    case DISABLE_OTP_SUCCESS:
      return {
        ...state,
        otpPath: action.payload.path,
        loading: false,
        success: { success: ['OTP Disabled'] },
        errors: [],
      };
    case DISABLE_OTP_FAIL:
      return {
        ...state,
        loading: false,
        errors: action.errors.response.data,
        success: [],
      };
    case ENABLE_OTP_SUCCESS:
      return {
        ...state,
        otpPath: action.payload.path,
        loading: false,
      };
    case ENABLE_OTP_FAIL:
      return {
        ...state,
        loading: false,
        errors: action.errors.response.data,
        success: [],
      };
    case TOGGLE_SIWE_SUCCESS:
      return {
        ...state,
        siweNonce: null,
        loading: false,
      };
    case TOGGLE_SIWE_FAIL:
      return {
        ...state,
        siweNonce: null,
        loading: false,
        errors: action.errors.response.data,
        success: [],
      };
    case ACTIVATE_OTP_SUCCESS:
      return {
        ...state,
        resetCode: action.payload.resetCode,
        loading: false,
        success: { success: ['OTP Activated. You will be logged out soon.'] },
        errors: [],
      };
    case ACTIVATE_OTP_FAIL:
      return {
        ...state,
        loading: false,
        errors: action.errors.response.data,
        success: [],
      };
    case UPDATE_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        errors: [],
        success: { success: [action.payload.message || action.payload.data.message] },
      };
    case UPDATE_USER_FAIL:
      return {
        ...state,
        errors: action.errors.response.data,
        success: [],
        loading: false,
      };
    case UPDATE_PWD_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case UPDATE_PWD_FAIL:
      return {
        ...state,
        errors: action.errors.response.data,
        loading: false,
      };
    case CREATE_IDENTITY_SUCCESS:
      return {
        ...state,
        loading: false,
        success: { success: [action.payload.message] },
        errors: [],
      };
    case CREATE_IDENTITY_FAIL:
      return {
        ...state,
        errors: action.errors.response.data,
        loading: false,
        success: [],
      };
    case FETCH_IDENTITY_SUCCESS:
      return {
        ...state,
        identity: action.payload,
        loading: false,
        errors: [],
      };
    case FETCH_IDENTITY_FAIL:
      return {
        ...state,
        errors: action.errors.response.data,
        loading: false,
      };
    case CREATE_DOCS_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case CREATE_DOCS_FAIL:
      return {
        ...state,
        errors: action.errors.response.data,
        loading: false,
      };
    case CREATE_TOKEN_SUCCESS:
      return {
        ...state,
        newtoken: action.payload,
        success: { success: ['New token created'] },
        errors: [],
        loading: false,
      };
    case CREATE_TOKEN_FAIL:
      return {
        ...state,
        errors: action.errors.response.data,
        success: [],
        loading: false,
      };
    case DELETE_TOKEN_SUCCESS:
      return {
        ...state,
        success: { success: ['Token deleted successfully'] },
        errors: [],
        loading: false,
      };
    case DELETE_TOKEN_FAIL:
      return {
        ...state,
        errors: action.errors.response.data,
        success: [],
        loading: false,
      };
    case FETCH_TOKENS_SUCCESS:
      return {
        ...state,
        apitokens: action.payload,
        loading: false,
      };
    case REQUEST_VERIFICATIONS_STATUS_BEGIN:
      return {
        ...state,
        verification: {
          loading: true,
        },
      };
    case REQUEST_VERIFICATIONS_STATUS_SUCCESS:
      return {
        ...state,
        verification: {
          ...action.payload,
          loading: false,
        },
      };
    case REQUEST_VERIFICATIONS_STATUS_FAILURE:
      return {
        ...state,
        errors: action.errors.response.data,
        verification: {
          loading: false,
        },
      };
    case TOGGLE_TEMP_ANON_SUCCESS:
      return {
        ...state,
        tempAnon: action.payload,
      };
    case CREATE_MASTER_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        success: { success: [action.payload.message || action.payload.data.message || 'Master Password Created'] },
      };
    case CREATE_MASTER_PASSWORD_FAIL:
      return {
        ...state,
        errors: action.errors.response.data,
        loading: false,
      };
    case RESET_MASTER_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        success: { success: [action.payload.message || action.payload.data.message || 'Master Password Updated'] },
      };
    case RESET_MASTER_PASSWORD_FAIL:
      return {
        ...state,
        errors: action.errors.response.data,
        loading: false,
      };
    case ACTIVATE_GLOBAL_SETTINGS_LOCK_SUCCESS:
      return {
        ...state,
        loading: false,
        success: { success: [action.payload.message || action.payload.data.message || 'Global Lock Enabled'] },
      };
    case ACTIVATE_GLOBAL_SETTINGS_LOCK_FAIL:
      return {
        ...state,
        errors: action.errors.response.data,
        loading: false,
      };
    case DEACTIVATE_GLOBAL_SETTINGS_LOCK_SUCCESS:
      return {
        ...state,
        loading: false,
        success: { success: [action.payload.message || action.payload.data.message || 'Global Lock Disabled'] },
      };
    case DEACTIVATE_GLOBAL_SETTINGS_LOCK_FAIL:
      return {
        ...state,
        errors: action.errors.response.data,
        loading: false,
      };
    case FETCH_LOGIN_HISTORY_SUCCESS:
      return {
        ...state,
        loginHistory: action.payload.data,
        loginPagination: action.payload.pagination,
        loading: false,
      };
    case FETCH_LOGIN_HISTORY_FAIL:
      return {
        ...state,
        loading: false,
        errors: action.payload,
      };
    case REQUEST_EMAIL_CHANGE_SUCCESS:
      return {
        ...state,
        loading: false,
        success: { success: [action.payload.message || action.payload.data.message || 'Email Change Received. Check Your Email To Confirm.'] },
      };
    case REQUEST_EMAIL_CHANGE_FAIL:
      return {
        ...state,
        errors: action.errors.response.data,
        loading: false,
      };
    case UPDATE_USER_TERMS_VERSION_SUCCESS:
      return {
        ...state,
        loading: false,
        errors: [],
        success: { success: [action.payload.message || action.payload.data.message] },
      };
    case UPDATE_USER_TERMS_VERSION_FAIL:
      return {
        ...state,
        errors: action.errors.response.data,
        success: [],
        loading: false,
      };
    case FETCH_LOGIN_SESSIONS_SUCCESS:
      return {
        ...state,
        loginSessions: action.payload,
        loading: false,
      };
    case FETCH_LOGIN_SESSIONS_FAIL:
      return {
        ...state,
        loading: false,
        errors: action.payload,
      };
    case EXPIRE_LOGIN_SESSION_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case EXPIRE_LOGIN_SESSION_FAIL:
      return {
        ...state,
        loading: false,
        errors: action.payload,
      };
    default:
      return state;
  }
};

export default user;
